// Armazón de la app: sidebar + navbar + contenido (Outlet) + scrim.
// Gestiona el colapso de la sidebar (desktop) y el drawer (móvil).
import { useState, type ReactNode } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';

export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const toggleMenu = () => {
    if (window.innerWidth <= 900) setDrawerOpen((o) => !o);
    else setCollapsed((c) => !c);
  };

  const cls = ['app', collapsed && 'collapsed', drawerOpen && 'drawer-open'].filter(Boolean).join(' ');

  return (
    <div className={cls}>
      <Sidebar onNavigate={() => setDrawerOpen(false)} />

      <div className="main">
        <Navbar onToggleMenu={toggleMenu} />
        {/* key por ruta: replica la animación viewIn en cada navegación. */}
        <main className="content" key={pathname}>
          {children}
        </main>
      </div>

      <div className="scrim" onClick={() => setDrawerOpen(false)} />
    </div>
  );
}
